var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
// import Geocode from "react-geocode";
// Geocode.setApiKey("AIzaSyDseP7HF_56aFB57irUQeEi5438tD4PSlk");
import { withTranslation } from 'react-i18next';

var layerDistributionContent = function (_Component) {
    _inherits(layerDistributionContent, _Component);

    function layerDistributionContent(props) {
        _classCallCheck(this, layerDistributionContent);

        var _this = _possibleConstructorReturn(this, (layerDistributionContent.__proto__ || Object.getPrototypeOf(layerDistributionContent)).call(this, props));

        _this.handleOnclick = function () {
            if (!_this.state.isOpen) {
                _this.props.centerMap(parseFloat(_this.props.content.latitud), parseFloat(_this.props.content.longitud));
                _this.setState({
                    isOpen: !_this.state.isOpen
                });
            } else {
                _this.setState({
                    isOpen: !_this.state.isOpen
                });
            }
        };

        _this.state = {
            stateClass: '',
            stateIconClass: '',
            backgroundColor: '',
            borderColor: '',
            label: '',
            valueFilter: '',
            address: undefined,
            isOpen: false
        };
        return _this;
    }

    _createClass(layerDistributionContent, [{
        key: 'render',
        value: function render() {
            // console.log("render - layerDistributionContent");
            var t = this.props.t;

            return React.createElement(
                'div',
                { className: this.state.label + " collapseDevices" },
                React.createElement(
                    'div',
                    { className: 'panel-body' },
                    React.createElement(
                        'div',
                        { className: 'panel-group' },
                        React.createElement(
                            'div',
                            { className: 'panel panel-default sub-group-content sub-group-1' },
                            React.createElement(
                                'a',
                                { 'data-toggle': 'collapse', 'data-parent': '#accordion',
                                    href: "#group-1-level-2__" + this.props.id, onClick: this.handleOnclick.bind(this) },
                                React.createElement(
                                    'div',
                                    { className: 'panel-heading map-content-level2' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-title' },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-heading' },
                                            React.createElement(
                                                'div',
                                                { className: 'level2-heading-left' },
                                                React.createElement('span', { className: "bg-left " + this.state.borderColor }),
                                                React.createElement('span', { className: this.state.stateIconClass }),
                                                React.createElement(
                                                    'span',
                                                    { className: 'trackerName' },
                                                    this.props.content.destinatario
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            React.createElement('div', { className: 'clearfix' }),
                            React.createElement(
                                'div',
                                { id: "group-1-level-2__" + this.props.id, className: "collapse " + this.state.borderColor },
                                React.createElement(
                                    'div',
                                    { className: this.state.backgroundColor, id: 'content-destino-bg_@destinations.Id', style: { width: "100%", height: "35px", padding: "7px", color: "#fff", fontSize: "16px" } },
                                    React.createElement(
                                        'ul',
                                        { className: 'list-unstyled' },
                                        React.createElement(
                                            'li',
                                            { style: { float: "left", marginRight: "6px" } },
                                            React.createElement(
                                                'svg',
                                                { style: { verticalAlign: "middle", marginRight: "3px", width: "15px", height: "15px", fill: "#000" }, id: 'Capa_1', height: '512', viewBox: '0 0 515.556 515.556', width: '512', xmlns: 'http://www.w3.org/2000/svg' },
                                                React.createElement('path', { d: 'm290 32.222c-113.405 0-207.262 84.222-222.981 193.333h-67.019l96.667 96.667 96.667-96.667h-61.188c14.972-73.444 80.056-128.889 157.854-128.889 88.832 0 161.111 72.28 161.111 161.111s-72.279 161.112-161.111 161.112c-51.684 0-100.6-25.079-130.84-67.056l-52.298 37.635c42.323 58.78 110.78 93.866 183.138 93.866 124.373 0 225.556-101.198 225.556-225.556s-101.183-225.556-225.556-225.556z' }),
                                                React.createElement('path', { d: 'm257.778 161.111v131.029l96.195 57.711 33.166-55.256-64.917-38.956v-94.527z' })
                                            )
                                        ),
                                        React.createElement(
                                            'li',
                                            null,
                                            React.createElement(
                                                'p',
                                                { style: { display: "inline", lineHeight: "1.3", color: "#000" } },
                                                t("map.sidebar.distributionContent.estimateState"),
                                                ': ',
                                                this.props.content.horaEntregaEstimada
                                            )
                                        )
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'panel-body level2-content' },
                                    React.createElement(
                                        'div',
                                        { className: 'level2-content-top' },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-content-inner' },
                                            React.createElement(
                                                'p',
                                                { className: 'level2-gps' },
                                                'GPS ',
                                                this.props.content.latitud,
                                                ', ',
                                                this.props.content.longitud
                                            )
                                        )
                                    ),
                                    this.props.content.tfnoDestinatario !== "" && this.props.content.descripcion !== "" && React.createElement(
                                        'div',
                                        { className: 'level2-content-middle' },
                                        React.createElement(
                                            'div',
                                            { className: 'panel-group' },
                                            React.createElement(
                                                'div',
                                                { className: 'panel panel-default map-content-level3' },
                                                React.createElement(
                                                    'a',
                                                    { 'data-toggle': 'collapse',
                                                        'data-parent': '#group-1-level-2__1-level-3__1',
                                                        href: "#group-1-level-2__1-level-3__1" + this.props.id + 21 },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-heading' },
                                                        React.createElement(
                                                            'div',
                                                            { className: 'panel-title' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'level3-heading' },
                                                                React.createElement(
                                                                    'div',
                                                                    { className: 'level3-heading-left', style: { color: "#000", fontWeight: "bold" } },
                                                                    React.createElement(
                                                                        'ul',
                                                                        { style: { fontSize: "11px", padding: "0" }, className: 'list-unstyled' },
                                                                        React.createElement(
                                                                            'li',
                                                                            null,
                                                                            React.createElement(
                                                                                'span',
                                                                                { style: { paddingLeft: "0" } },
                                                                                t("map.sidebar.distributionContent.clientData")
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            'span',
                                                                            null,
                                                                            React.createElement('span', {
                                                                                className: 'icon-colapse_down' })
                                                                        )
                                                                    )
                                                                ),
                                                                React.createElement('div', { className: 'level3-heading-right' })
                                                            )
                                                        )
                                                    )
                                                ),
                                                React.createElement(
                                                    'div',
                                                    { id: "group-1-level-2__1-level-3__1" + this.props.id + 21,
                                                        className: 'panel-collapse collapse map-content-level3' },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-body' },
                                                        React.createElement(
                                                            'table',
                                                            { style: { marginLeft: "10px", fontSize: "11px" } },
                                                            React.createElement(
                                                                'tbody',
                                                                null,
                                                                React.createElement(
                                                                    'tr',
                                                                    null,
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        this.props.content.tfnoDestinatario
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    this.props.content.productList.length > 0 && React.createElement(
                                        'div',
                                        { className: 'level2-content-bottom' },
                                        React.createElement(
                                            'div',
                                            { className: 'panel-group' },
                                            React.createElement(
                                                'div',
                                                { className: 'panel panel-default map-content-level3' },
                                                React.createElement(
                                                    'a',
                                                    { 'data-toggle': 'collapse',
                                                        'data-parent': '#group-1-level-2__1-level-3__1',
                                                        href: "#group-1-level-2__1-level-3__12" + this.props.id + 51 },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-heading' },
                                                        React.createElement(
                                                            'div',
                                                            { className: 'panel-title' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'level3-heading' },
                                                                React.createElement(
                                                                    'div',
                                                                    { className: 'level3-heading-left', style: { color: "#000", fontWeight: "bold" } },
                                                                    React.createElement(
                                                                        'ul',
                                                                        { style: { fontSize: "11px", padding: "0", marginBottom: "0px" }, className: 'list-unstyled' },
                                                                        React.createElement(
                                                                            'li',
                                                                            null,
                                                                            React.createElement(
                                                                                'span',
                                                                                { style: { paddingLeft: "0" } },
                                                                                t("map.sidebar.distributionContent.products")
                                                                            ),
                                                                            React.createElement('span', { className: 'icon-colapse_down', style: { float: "right" } })
                                                                        )
                                                                    )
                                                                ),
                                                                React.createElement('div', { className: 'clearfix' })
                                                            )
                                                        ),
                                                        React.createElement('div', { className: 'clearfix' })
                                                    )
                                                ),
                                                React.createElement(
                                                    'div',
                                                    { id: "group-1-level-2__1-level-3__12" + this.props.id + 51,
                                                        className: 'panel-collapse collapse map-content-level3' },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-body' },
                                                        React.createElement(
                                                            'table',
                                                            { style: { width: "100%" }, className: 'tableProducts' },
                                                            React.createElement(
                                                                'tbody',
                                                                null,
                                                                this.props.content.productList !== undefined && this.props.content.productList.map(function (item) {
                                                                    return React.createElement(
                                                                        'tr',
                                                                        { key: item.id },
                                                                        React.createElement(
                                                                            'td',
                                                                            null,
                                                                            item.descripcion
                                                                        ),
                                                                        React.createElement(
                                                                            'td',
                                                                            null,
                                                                            item.cantidad,
                                                                            React.createElement('sup', null)
                                                                        )
                                                                    );
                                                                })
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, state) {
            if (props.content !== undefined) {
                var _ref = '',
                    stateClass = _ref.stateClass,
                    stateIconClass = _ref.stateIconClass,
                    backgroundColor = _ref.backgroundColor,
                    borderColor = _ref.borderColor;

                if (props.content.idETipoEstadoTipoServicio === 2) {
                    //Finalizado
                    stateClass = 'map-green-bg';
                    stateIconClass = 'newIcon-destino_hecho';
                    borderColor = 'content-green-borderbg';
                    backgroundColor = 'content-green-bg';
                }
                if (props.content.idETipoEstadoTipoServicio === 1) {
                    //En proceso
                    stateClass = 'map-yellow-bg';
                    stateIconClass = 'newIcon-destino_posible_retraso';
                    borderColor = 'content-yellow-borderbg';
                    backgroundColor = 'content-yellow-bg';
                }
                // if (props.content === "Retraso") {
                //     stateClass = 'map-gray-bg';
                //     stateIconClass = 'newIcon-destino_pendiente';
                //     borderColor = 'content-gray-borderbg';
                //     backgroundColor = 'content-gray-bg';
                // }
                // if (props.device.assetsIOTInfo[0].gpsInfo.speed === undefined) {
                //     stateClass = 'map-blue-bg'
                //     stateIconClass = 'icon-no_gprs'
                //     label = 'No-GPRS'
                // }

                return {
                    stateClass: stateClass,
                    stateIconClass: stateIconClass,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor
                };
            } else {
                return null;
            }
        }

        // getAddress(lat, lng) {

        //     if (lat !== 0) {
        //         lat = lat.toString();
        //         lng = lng.toString();

        //         return Geocode.fromLatLng(lat, lng).then(
        //             response => {
        //                 const location = response.results[0].formatted_address;
        //                 return location
        //             },
        //             error => {
        //                 console.error(error);
        //             }
        //         );
        //     }
        // }

        // calc(num) {
        //     var with6Decimals = num.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0]
        //     return with6Decimals
        // }

    }]);

    return layerDistributionContent;
}(Component);

export default withTranslation()(layerDistributionContent);